import React from "react";
import AboutBanner from "../sections/about/AboutBanner";
import AboutVisionMissionSection from "../sections/about/AboutVisionMissionSection";
import HomeCtaBannerSection from "../sections/home/HomeCtaBannerSection";
import {ServicesFaqSection,} from "../sections/services";
import StatsMarqueeSection from "../sections/home/StatsMarqueeSection";

const About: React.FC = () => {
  return (
    <div>
      <AboutBanner />
      <AboutVisionMissionSection />
      <StatsMarqueeSection />
      <ServicesFaqSection />
      <HomeCtaBannerSection />
    </div>
  );
};

export default About;
